export const FETCH_PROSPECT_CLIENT = 'FETCH_PROSPECT_CLIENT'
export const GET_PROSPECT_CLIENT = 'GET_PROSPECT_CLIENT'

